import { MenuPoint } from '@agilox/ui-common';
import { manageMenuPoints } from './menupoints';

export const desktopMenuPoints: MenuPoint[] = [
	manageMenuPoints.users,
	manageMenuPoints.vehicles,
	manageMenuPoints.notifications,
	manageMenuPoints.help,
	manageMenuPoints.logout,
];
